export default "__VITE_ASSET__R54TxuQr__"